module.exports = __webpack_public_path__ + "images/graphic-panel-1_f8982500c0d2eed6fc1d59dba82c3836.png";